export default __webpack_public_path__ + "static/media/logo-truebond.9c0602ea.webp";